export default "__VITE_ASSET__0fUAPyEr__"